module.exports = __webpack_public_path__ + "img/announcement_2024_11_01_steps.1c11b74c.svg";